module.exports = __webpack_public_path__ + "img/froot_logo.9f0f85ac.jpg";